import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'performance_process/goals',
  children: {
    employees: {
      path: 'employees',
      children: {
        employee: {
          path: ':id',
        },
      },
    },
    groups: {
      path: 'groups',
      children: {
        group: {
          path: ':id',
        },
      },
    },
  },
} as const satisfies Location
